import React from 'react';
import { ChevronRightIcon, LockIcon } from '@domain-group/fe-co-icon';
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import { RowButton, Separator } from '@domain-group/fe-co-allhomes-design-system';
var pngImage = "https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-co-allhomes-nearby-sales/static/nearby-sales-cta_0e58373d.png";
var webpImage = "https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-co-allhomes-nearby-sales/static/nearby-sales-cta_16b63508.webp";
var webp2xImage = "https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-co-allhomes-nearby-sales/static/nearby-sales-cta-2x_c0cb07b4.webp";
import styleFactory from './signed-out.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var SignedOut = _ref => {
  var layout = _ref.layout,
    nearbySales = _ref.nearbySales,
    propertyType = _ref.propertyType,
    line1 = _ref.line1,
    division = _ref.division,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? () => {} : _ref$onClick;
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var _ref2 = nearbySales || {},
    count = _ref2.count,
    bedrooms = _ref2.bedrooms;
  var styles = styleFactory(layout);
  var handleClick = args => {
    sendEvent('nearby-sales-sign-in');
    onClick(args);
  };
  return ___EmotionJSX("div", {
    css: styles.nearbySales
  }, ___EmotionJSX("picture", null, ___EmotionJSX("source", {
    srcSet: "".concat(webp2xImage, " 2x"),
    type: "image/webp"
  }), ___EmotionJSX("source", {
    srcSet: webpImage,
    type: "image/webp"
  }), ___EmotionJSX("img", {
    css: styles.image,
    src: pngImage,
    alt: ""
  })), ___EmotionJSX("div", {
    css: styles.body
  }, ___EmotionJSX("div", {
    css: styles.heading
  }, "Looking to compare sales prices?"), ___EmotionJSX("p", {
    css: styles.text
  }, "We found", ' ', ___EmotionJSX("strong", null, count, " ", propertyType), ' ', "with ", ___EmotionJSX("strong", null, bedrooms, " bedrooms"), " that just sold near", ' ', ___EmotionJSX("strong", null, line1, " ", division)), ___EmotionJSX(Separator, {
    css: styles.separator
  }), ___EmotionJSX(RowButton, {
    css: styles.button,
    leftIcon: ___EmotionJSX(LockIcon, {
      css: styles.buttonIcon
    }),
    title: ___EmotionJSX("span", {
      css: styles.buttonText
    }, "Sign in to view properties"),
    rightIcon: ___EmotionJSX(ChevronRightIcon, {
      css: styles.buttonIcon
    }),
    rightIconSize: "medium",
    collapse: true,
    hasPadding: false,
    onClick: handleClick,
    colours: styles.buttonColours
  })));
};
export default SignedOut;